import { QueryClientProvider } from '@tanstack/react-query';
import { configureRequestContext, queryClient, syncRequestContext } from './query/client';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import { captureAwinClick } from './services/awinClickCapture';
import { initializeAwinMasterTag } from './services/awinMasterTag';
import './services/posthog';

configureRequestContext(() => {
    const profile = (store.getState() as any).Co2Profile;
    return profile?.user?.id ? {
        userId: profile.user.id,
        businessId: profile.userBusiness?.id ?? null,
        siteId: profile.userSite?.id ?? null,
        affiliateId: profile.userAffiliate?.id ?? null,
    } : null;
});
store.subscribe(syncRequestContext);

captureAwinClick();
initializeAwinMasterTag();

// Defer FontAwesome loading - it's heavy and not needed immediately
// Use requestIdleCallback for better performance
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    import('./assets/vendor/fontawesome-kit-9a5e609df7/icons/css/all.min.css')
      .then(() => import('./assets/vendor/fontawesome-pro-7/css/all.min.css'));
  });
} else {
  setTimeout(() => {
    import('./assets/vendor/fontawesome-kit-9a5e609df7/icons/css/all.min.css')
      .then(() => import('./assets/vendor/fontawesome-pro-7/css/all.min.css'));
  }, 1);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <React.Fragment>
        <BrowserRouter basename={import.meta.env.BASE_URL}>
          <App />
        </BrowserRouter>
      </React.Fragment>
    </Provider>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
